import cacheableRequest from '../../../services/cacheableRequest';
import { AxiosResponse } from 'axios';

export type GetCurriculumResponse = {
  id: string;
  name: string;
  brandCode: string;
  brand: string;
  plusItemNumber: string;
  basicItemNumber: string;
  offCycleEnabled?: boolean;
};

export const getCurriculumById = (curriculumId: string) =>
  cacheableRequest(`/curriculum-api/curriculums/${curriculumId}`, 60).then(
    (response: AxiosResponse<GetCurriculumResponse>) => response.data
  );
